module.exports = __webpack_public_path__ + "img/events-logo.efa734ce.png";